package uz.ferro.erp.feature.faq.data

import uz.ferro.erp.api.suspendGet
import uz.ferro.erp.feature.faq.model.FaqGroup
import uz.ferro.erp.feature.faq.model.FaqItem

object FaqManager {

    suspend fun getData(): List<FaqGroup> {
        val items: List<FaqGroup> = suspendGet(
            path = "/data/faq.json",
            modifyPathDisabled = true
        )
        return items
    }

    suspend fun getHomeItems(): List<FaqItem> {
        return emptyList()
    }
}